import { AbstractControl, ValidatorFn } from '@angular/forms';

export function matchEmailValidator(emailControl: AbstractControl): ValidatorFn {
  return (confirmEmailControl: AbstractControl): { [key: string]: any } => {
    const email = typeof emailControl.value === 'string' ? emailControl.value : '';
    const confirmEmail = typeof confirmEmailControl.value === 'string' ? confirmEmailControl.value : '';
    return email.toLowerCase() === confirmEmail.toLowerCase() ? null : { matchemail: { valid: false } };
  };
}



// WEBPACK FOOTER //
// ./src/app/global/match-email.validator.ts